const campaignFullDetails = `
  fragment campaignFullDetails on Campaign {
    id
    name
    status
    shortUrl
    targetCountries{
      iso2
    }
    campaignImage{
      publicUrl
    }
    categories{
      name
    }
    apiDoc
    trafficSource{
      key
    }
    trafficSourceApi{
      key
    }
    restrictions{
      name
    }
    creatives{
      id
      name
      image{
        publicUrl
      }
    }
    emailTemplates{
      id
      name
      htmlContent
    }
    userPrices{
      model
      price
    }
    rating
    reviewCount
    description
    landingUrl
    bankosCampaign
    pricings{
      model{
        id
        name
        type
      }
      normal: publisherPrice
      volume: publisherPriceVolume
      extraVolume: publisherPriceExtraVolume
    }
  }
`

export { campaignFullDetails }